// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3FJdw","disabled":"FileBtn_disabled__3nBso","warn":"FileBtn_warn__ZT2-v","fade":"FileBtn_fade__1gd1H"};